@if (isWrongVersion) {
<div class="version-warning-text select-none cursor-pointer" (click)="reload()">
  A new version is available! Please refresh to get the latest version of the app.
</div>
}
